"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_transition_group_1 = require("react-transition-group");
require("./index.css");
exports.Scroll = function (_a) {
    var displayHeight = _a.displayHeight, icon = _a.icon, color = _a.color, iconSize = _a.iconSize, bgSize = _a.bgSize, borderRadius = _a.borderRadius, position = _a.position, xOffset = _a.xOffset, yOffset = _a.yOffset, zIndex = _a.zIndex;
    var Wrap = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    position: fixed;\n    bottom: 25px;\n    left: ", ";\n    right: ", ";\n    transform: ", ";\n    z-index: ", ";\n    color: white;\n    background-color: ", ";\n    border: 1px solid rgba(0, 0, 0, 0);\n    transition: all 0.5s;\n    &:hover {\n      background-color: white;\n      color: ", ";\n      border: 1px solid ", ";\n    }\n  "], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    position: fixed;\n    bottom: 25px;\n    left: ", ";\n    right: ", ";\n    transform: ",
        ";\n    z-index: ", ";\n    color: white;\n    background-color: ", ";\n    border: 1px solid rgba(0, 0, 0, 0);\n    transition: all 0.5s;\n    &:hover {\n      background-color: white;\n      color: ", ";\n      border: 1px solid ", ";\n    }\n  "])), bgSize ? bgSize + "px" : '40px', bgSize ? bgSize + "px" : '40px', borderRadius ? borderRadius : '5px', position === 'bottom-left' ? '25px' : null, position === 'bottom-right' ? '25px' : '25px', "translate(" + (xOffset ? xOffset : 0) + "px, " + (yOffset ? yOffset : 0) + "px)", zIndex ? zIndex : 0, color ? color : 'black', color ? color : 'black', color ? color : 'black');
    var Arrow = styled_components_1.default.i(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), iconSize ? iconSize + "px" : '20px');
    var _b = react_1.useState(false), showBtn = _b[0], setShowBtn = _b[1];
    var handleScroll = function () {
        var displayPosition;
        if (displayHeight) {
            displayPosition = displayHeight;
        }
        else {
            displayPosition = 300;
        }
        var position = window.pageYOffset;
        if (position > displayPosition) {
            setShowBtn(true);
        }
        else {
            setShowBtn(false);
        }
    };
    react_1.useEffect(function () {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var scrollTop = function () {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    };
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: showBtn, timeout: 500, classNames: "fade-in", unmountOnExit: true },
        react_1.default.createElement(Wrap, { onClick: scrollTop, className: "scroll-to-top-btn-container" },
            react_1.default.createElement(Arrow, { className: icon ? icon : 'fas fa-arrow-up' }))));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map